import { useEffect, useRef } from 'react';

const ENTER_KEYCODE = 13;

function useEnterPress(active: boolean, onEnterPress: (() => void) | undefined) {
  const handleEnterRef = useRef(onEnterPress);

  useEffect(() => {
    handleEnterRef.current = onEnterPress;
  }, [onEnterPress]);

  useEffect(() => {
    const handleKeyboard = (event: KeyboardEvent) => {
      if (event.keyCode === ENTER_KEYCODE && handleEnterRef.current) {
        handleEnterRef.current();
      }
    };

    window.addEventListener('keydown', handleKeyboard);

    return () => {
      window.removeEventListener('keydown', handleKeyboard);
    };
  }, [active]);
}

export { useEnterPress };
